var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ActivtyTask" } }, [
    _c("div", { staticClass: "section-title" }, [_vm._v("Hareketler")]),
    _vm._v(" "),
    _c("div", { staticClass: "activity-container" }, [
      _vm.activities === null
        ? _c(
            "div",
            { staticClass: "skeleton-list" },
            _vm._l(5, function (i) {
              return _c("div", { key: i, staticClass: "skeleton-item" }, [
                _c("div", { staticClass: "skeleton-avatar" }),
                _vm._v(" "),
                _vm._m(0, true),
              ])
            }),
            0
          )
        : _vm.activities && _vm.activities.length
        ? _c(
            "div",
            { staticClass: "activity-list" },
            [
              _vm._l(_vm.activities, function (activity) {
                return _c(
                  "div",
                  { key: activity._id, staticClass: "activity-item" },
                  [
                    _c("div", { staticClass: "activity-left" }, [
                      _c(
                        "div",
                        { staticClass: "avatar-wrapper" },
                        [
                          activity.actor === "user"
                            ? _c("Avatar", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                    },
                                    expression:
                                      "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                  },
                                ],
                                attrs: {
                                  size: 32,
                                  src:
                                    _vm.usersMap[activity.actorUser] &&
                                    _vm.usersMap[activity.actorUser].gravatar,
                                  username:
                                    _vm.usersMap[activity.actorUser] &&
                                    _vm.usersMap[activity.actorUser].name,
                                  content:
                                    _vm.usersMap[activity.actorUser] &&
                                    _vm.usersMap[activity.actorUser].email,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          activity.actor === "chatbot"
                            ? _c("Avatar", {
                                attrs: {
                                  size: 32,
                                  username: "Chatbot",
                                  src: _vm
                                    .baseUrl()
                                    .concat("static/img/chatbot-bg.png"),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          activity.actor === "system"
                            ? _c("Avatar", {
                                attrs: {
                                  size: 32,
                                  username: "System",
                                  src: _vm
                                    .baseUrl()
                                    .concat("static/img/minilogo4.png"),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "timeline-line" }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "activity-body" }, [
                      _c("div", { staticClass: "activity-header" }, [
                        activity.actor === "user"
                          ? _c("span", { staticClass: "user-name" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    (_vm.usersMap[activity.actorUser] &&
                                      _vm.usersMap[activity.actorUser].name) ||
                                      "Bilinmeyen Kullanıcı"
                                  ) +
                                  "\n                        "
                              ),
                            ])
                          : activity.actor === "chatbot"
                          ? _c("span", { staticClass: "user-name" }, [
                              _vm._v("ChatBot"),
                            ])
                          : _c("span", { staticClass: "user-name" }, [
                              _vm._v("Sistem"),
                            ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "activity-time" }, [
                          _vm._v(
                            _vm._s(_vm.$moment(activity.updatedAt).fromNow())
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "activity-content",
                        domProps: {
                          innerHTML: _vm._s(_vm.getActivityContent(activity)),
                        },
                      }),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.hasMore
                ? _c(
                    "div",
                    { staticClass: "load-more-container" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { loading: _vm.loading, type: "link" },
                          on: { click: _vm.loadMore },
                        },
                        [
                          _vm._v(
                            "\n                    Daha Fazla Yükle\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "empty-state" },
            [
              _c("a-icon", {
                staticClass: "empty-icon",
                attrs: { type: "file-text" },
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Henüz bir hareket bulunmuyor.")]),
            ],
            1
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-body" }, [
      _c("div", { staticClass: "skeleton-line short" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-line long" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }